"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Footer;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Footer() {
  return _react2.default.createElement(
    "footer",
    { className: "Footer l-footer", itemScope: true, itemType: "https://schema.org/WPFooter" },
    _react2.default.createElement("style", { "data-type": "vc_shortcodes-custom-css", type: "text/css", dangerouslySetInnerHTML: { __html: '.vc_custom_1508763442311{padding-top: 50px !important;padding-bottom: 50px !important;}' } }),
    _react2.default.createElement(
      "section",
      { className: "l-section wpb_row height_auto color_footer-bottom ult-vc-hide-row vc_row-has-fill", "data-row-effect-mobile-disable": "true", "data-rtl": "false", style: { paddingTop: '50px !important', paddingBottom: '50px !important', position: 'relative' } },
      _react2.default.createElement("div", { className: "upb_row_bg", "data-bg-override": 0, style: { background: 'rgb(17, 40, 71)', minWidth: 1024, left: 0, width: 1023 } }),
      _react2.default.createElement(
        "div",
        { className: "l-section-h i-cf" },
        _react2.default.createElement(
          "div",
          { className: "g-cols vc_row type_default valign_top" },
          _react2.default.createElement(
            "div",
            { className: "vc_col-sm-6 wpb_column vc_column_container" },
            _react2.default.createElement(
              "div",
              { className: "vc_column-inner" },
              _react2.default.createElement(
                "div",
                { className: "wpb_wrapper" },
                _react2.default.createElement(
                  "div",
                  { className: "wpb_text_column" },
                  _react2.default.createElement(
                    "div",
                    { className: "wpb_wrapper" },
                    _react2.default.createElement(
                      "h6",
                      { style: { color: 'white' } },
                      "PRESL",
                      _react2.default.createElement("br", null),
                      "P\xF4le r\xE9gional d\u2019\xE9conomie sociale \xE0 Laval"
                    ),
                    _react2.default.createElement(
                      "p",
                      { style: { color: 'white' } },
                      "1200 Boulevard Saint-Martin O, suite 130,",
                      _react2.default.createElement("br", null),
                      "Laval (Qc), H7S 2E4"
                    ),
                    _react2.default.createElement(
                      "p",
                      { style: { color: 'white' } },
                      "T\xE9l\xE9phone: 514 267-7441",
                      _react2.default.createElement("br", null),
                      "Courriel: ",
                      _react2.default.createElement(
                        "a",
                        { href: "mailto:info@presdelaval.org" },
                        "info@presdelaval.org"
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "vc_col-sm-6 wpb_column vc_column_container" },
            _react2.default.createElement(
              "div",
              { className: "vc_column-inner" },
              _react2.default.createElement(
                "div",
                { className: "wpb_wrapper" },
                _react2.default.createElement(
                  "div",
                  { className: "g-cols wpb_row type_default valign_top vc_inner" },
                  _react2.default.createElement(
                    "div",
                    { className: "vc_col-sm-12 wpb_column vc_column_container" },
                    _react2.default.createElement(
                      "div",
                      { className: "vc_column-inner" },
                      _react2.default.createElement(
                        "div",
                        { className: "wpb_wrapper" },
                        _react2.default.createElement(
                          "div",
                          { className: "wpb_text_column" },
                          _react2.default.createElement(
                            "div",
                            { className: "wpb_wrapper" },
                            _react2.default.createElement(
                              "h6",
                              { style: { color: 'white' } },
                              "Nous rejoindre"
                            )
                          )
                        ),
                        _react2.default.createElement(
                          "div",
                          { className: " uavc-icons" },
                          _react2.default.createElement(
                            "a",
                            { className: "aio-tooltip 5a270bd8235c2", "data-placement": true, "data-toggle": "tooltip", href: "https://www.facebook.com/P%C3%B4le-R%C3%A9gional-d%C3%89conomie-Sociale-de-Laval-1070287139717184", rel: "noopener", target: "_blank", title: true },
                            _react2.default.createElement(
                              "div",
                              { className: "aio-icon", "data-animation": true, "data-animation-delay": 3, style: { color: '#ffffff', fontSize: 20, marginRight: 0 } },
                              _react2.default.createElement("i", { className: "Defaults-facebook facebook-f" })
                            )
                          ),
                          " ",
                          _react2.default.createElement(
                            "a",
                            { className: "aio-tooltip 5a270bd82367c", "data-placement": true, "data-toggle": "tooltip", href: "https://twitter.com/presdelaval", rel: "noopener", target: "_blank", title: true },
                            _react2.default.createElement(
                              "div",
                              { className: "aio-icon", "data-animation": true, "data-animation-delay": 3, style: { color: '#ffffff', fontSize: 20, marginRight: 0 } },
                              _react2.default.createElement("i", { className: "Defaults-twitter" })
                            )
                          ),
                          " ",
                          _react2.default.createElement(
                            "a",
                            { className: "aio-tooltip 5a270bd823701", "data-placement": true, "data-toggle": "tooltip", href: "https://www.linkedin.com/company/11074109/", rel: "noopener", target: "_blank", title: true },
                            _react2.default.createElement(
                              "div",
                              { className: "aio-icon", "data-animation": true, "data-animation-delay": 3, style: { color: '#ffffff', fontSize: 20, marginRight: 5 } },
                              _react2.default.createElement("i", { className: "Defaults-linkedin" })
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      )
    ),
    _react2.default.createElement(
      "section",
      { className: "l-section wpb_row height_auto ult-vc-hide-row vc_row-has-fill", "data-row-effect-mobile-disable": "true", "data-rtl": "false", style: { position: 'relative' } },
      _react2.default.createElement("div", { className: "upb_row_bg", "data-bg-override": 0, style: { background: 'rgb(31, 61, 87)', minWidth: 1024, left: 0, width: 1023 } }),
      _react2.default.createElement(
        "div",
        { className: "l-section-h i-cf" },
        _react2.default.createElement(
          "div",
          { className: "g-cols vc_row type_default valign_top" },
          _react2.default.createElement(
            "div",
            { className: "vc_col-sm-12 wpb_column vc_column_container" },
            _react2.default.createElement(
              "div",
              { className: "vc_column-inner" },
              _react2.default.createElement(
                "div",
                { className: "wpb_wrapper" },
                _react2.default.createElement(
                  "div",
                  { className: "wpb_text_column" },
                  _react2.default.createElement(
                    "div",
                    { className: "wpb_wrapper" },
                    _react2.default.createElement(
                      "p",
                      { style: { textAlign: 'left', color: 'white', fontSize: 10 } },
                      "\xA9 2015 PRESL \u2013 Tous droits r\xE9serv\xE9s"
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer.js
// module id = 1143
// module chunks = 0